import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";

const navItems = [
  { to: "/admin", label: "Overview", end: true },
  { to: "/admin/users", label: "Users" },
  { to: "/admin/licences", label: "Licences" },
  { to: "/admin/coupons", label: "Coupons" },
  { to: "/admin/affiliates", label: "Affiliates" },
  { to: "/admin/orders", label: "Orders" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#050505]">
      <header className="border-b border-white/10 bg-[#0a0a0c]">
        <div className="max-w-[1360px] mx-auto px-4 md:px-7 h-[76px] flex items-center justify-between">
          <div className="flex items-center gap-3 md:gap-4">
            <NavLink to="/" className="block">
              <img src="/voleor-logo.png" alt="Voleor" className="h-[27px] w-auto" />
            </NavLink>
            <span className="text-xs bg-[#FF5500]/10 text-[#FF5500] px-2 py-1 rounded">Admin</span>
          </div>
          <div className="flex items-center gap-3 md:gap-4">
            <NavLink to="/dashboard" className="text-sm text-[#A1A1AA] hover:text-white">Dashboard</NavLink>
            <button onClick={async () => { await logout(); navigate("/"); }} className="text-sm text-[#A1A1AA] hover:text-white">Logout</button>
          </div>
        </div>
      </header>
      <div className="max-w-[1360px] mx-auto px-4 md:px-7 py-6 md:py-8 flex flex-col md:flex-row gap-6 md:gap-8">
        {/* Sidebar on desktop, scrollable tab strip on mobile: a fixed w-48
            column left barely 110px for the content on a 390px screen. */}
        <nav className="w-full md:w-48 shrink-0">
          <ul className="flex gap-1 overflow-x-auto -mx-4 px-4 md:mx-0 md:px-0 md:block md:space-y-1">
            {navItems.map((item) => (
              <li key={item.to} className="shrink-0">
                <NavLink to={item.to} end={item.end}
                  className={({ isActive }) =>
                    `block px-4 py-2 rounded text-sm whitespace-nowrap transition-colors ${isActive ? "bg-[#FF5500]/10 text-[#FF5500]" : "text-[#A1A1AA] hover:text-white hover:bg-white/5"}`
                  }>{item.label}</NavLink>
              </li>
            ))}
          </ul>
        </nav>
        <main className="flex-1 min-w-0"><Outlet /></main>
      </div>
    </div>
  );
}
